import { render, staticRenderFns } from "./pile-modal.vue?vue&type=template&id=88ccd59c&scoped=true"
import script from "./pile-modal.vue?vue&type=script&lang=js"
export * from "./pile-modal.vue?vue&type=script&lang=js"
import style0 from "./pile-modal.vue?vue&type=style&index=0&id=88ccd59c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ccd59c",
  null
  
)

export default component.exports